var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Main',{ref:"main",staticClass:"h-full",attrs:{"on-params":_vm.onParams,"columns":_vm.columns,"is-selection":false,"api":"/log/list"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }